import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-based auth: the backend issues an HttpOnly, Secure, SameSite=Strict
// session cookie on login. The browser sends it automatically when
// withCredentials is true. The JS layer never sees or stores the token.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchGeneralSettings() {
  const { data } = await api.get("/settings/general");
  return data;
}

export async function fetchDstSettings() {
  const { data } = await api.get("/settings/dst");
  return data;
}

export async function login(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function logout() {
  try {
    await api.post("/auth/logout");
  } catch {
    // ignore — cookie may already be expired
  }
}

export async function me() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function updateGeneralSettings(payload) {
  const { data } = await api.put("/admin/general", payload);
  return data;
}

export async function updateDst(payload) {
  const { data } = await api.put("/admin/dst", payload);
  return data;
}

export async function resetDefaults() {
  const { data } = await api.post("/admin/reset-defaults");
  return data;
}

export async function changePassword(current_password, new_password) {
  const { data } = await api.post("/admin/change-password", { current_password, new_password });
  return data;
}

export async function fetchAuditLogs({ limit = 25, offset = 0, action, q, dateFrom, dateTo } = {}) {
  const params = { limit, offset };
  if (action) params.action = action;
  if (q) params.q = q;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  const { data } = await api.get("/admin/audit-logs", { params });
  return data;
}

export async function downloadAuditExport(filters = {}) {
  const res = await api.get("/admin/audit-logs/export", {
    params: {
      action: filters.action || undefined,
      q: filters.q || undefined,
      date_from: filters.dateFrom || undefined,
      date_to: filters.dateTo || undefined,
    },
    responseType: "blob",
  });
  const blob = new Blob([res.data], { type: "text/csv" });
  const cd = res.headers["content-disposition"] || "";
  const match = cd.match(/filename="?([^";]+)"?/);
  const filename = match ? match[1] : `audit-logs-${Date.now()}.csv`;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function clearAuditLogs({ olderThanDays } = {}) {
  const params = {};
  if (olderThanDays) params.older_than_days = olderThanDays;
  const { data } = await api.delete("/admin/audit-logs", { params });
  return data;
}
